import { render, staticRenderFns } from "./kyc-withdraw-detail.vue?vue&type=template&id=18ccb028&"
import script from "./kyc-withdraw-detail.vue?vue&type=script&lang=js&"
export * from "./kyc-withdraw-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports